import { Message, MessageItem } from '@app/models'

export const getMessages = (
  lastMessage?: Message,
  prevMessages?: Array<MessageItem>
): Message[] => {
  const initialMessages = lastMessage ? [lastMessage] : []

  if (!prevMessages?.length) {
    return initialMessages
  }

  const firstMessage = prevMessages[0]
  if (firstMessage?.uuid || firstMessage?.id === lastMessage?.id) {
    return [...initialMessages, ...prevMessages.slice(1)]
  }

  return [...initialMessages, ...prevMessages]
}
